module.exports = __webpack_public_path__ + "img/category-favorite-hover.f7493bb8.png";